import React from 'react'

function FormTextarea({
    label,
    required = false,
    name,
    value,
    onChange,
    error,
    disabled = false,
}) {
    return (
        <div>

            <label className="text-sm mb-1 block">

                {label}

                {required && (
                    <span className="text-red-500 text-sm">
                        {' '}*
                    </span>
                )}

            </label>

            <textarea
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                className={`
                    textarea
                    textarea-bordered
                    textarea-md
                    w-full
                    ${error ? 'border-error' : ''}
                `}
            />

            {error && (
                <p className="text-red-500 text-xs mt-1">
                    {error}
                </p>
            )}

        </div>
    )
}

export default FormTextarea